import React from 'react';
import {useSelector} from 'react-redux';
import {LabelItem} from './label-item';
import './labeling-page.css';
/**
 * General component used as container for labels and showing them as list.
 */


export const LabelingView= () => {
    const labels = useSelector(state=> state.labelsData.labels);
    return (
        <div className="labeling-view">
            <div className="label-list">
                {labels.map((label, index) => (
                    <LabelItem key={label.Title + '_' + index} index={index} label={label}/>
                ))}
            </div>

        </div>
    );
}